<template>
  <v-form ref="form" v-model="valid">
    <v-row>
      <v-col cols="6" class="pb-0">
        <v-text-field
          autofocus
          @keydown.enter.prevent=""
          :label=" $t('label-name') "
          :hint="$t('hint-name')"
          v-model="fields.name"
          :rules="rules.name" required>
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pb-0">
        <v-text-field
          @keydown.enter.prevent=""
          :label="$t('label-email')"
          :hint="$t('hint-email')"
          v-model="fields.email">
        </v-text-field>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field
          @keydown.enter.prevent=""
          :label="$t('label-address')"
          v-model="fields.address.line1"
          :rules="rules.address.line1"
          required>
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field
          @keydown.enter.prevent=""
          :label="$t('label-cp')"
          v-model="fields.address.postal_code"
          :rules="rules.address.postal_code"
          required>
        </v-text-field>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0">
        <v-text-field
          @keydown.enter.prevent=""
          :label="$t('label-city')"
          v-model="fields.address.city"
          :rules="rules.address.city"
          required>
        </v-text-field>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-autocomplete
          @keydown.enter.prevent=""
          :label="$t('label-country')"
          v-model="fields.address.country"
          :items="$locale.countriesItems"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <small>{{ $t('required.fields') }}</small>
  </v-form>
</template>

<script>
import { pick } from 'lodash'

export default {
  name: 'ACustomerForm',
  data () {
    return {
      valid: false,
      fields: {
        name: '',
        address: {
          city: '',
          country: '',
          line1: '',
          postal_code: ''
        },
        email: ''
      },
      rules: {
        address: {
          city: [v => !!v || this.$t('required.city')],
          country: [v => !!v || this.$t('required.country')],
          line1: [v => !!v || this.$t('required.address')],
          postal_code: [v => !!v || this.$t('required.cp')],
        },
        name: [v => !!v || this.$t('required.name')]
      }
    }
  },
  watch: {
    valid () {
      this.$emit('valid', this.valid)
    }
  },
  methods: {
    async submit () {
      this.$emit('message', this.$t('messages.updating'))
      await this.$api.post('account/customer', this.fields)
      this.$emit('message', this.$t('messages.fetching'))
      await this.$account.fetch()
      return this.$t('messages.success')
    },
    fill () {
      if (this.$account.current.customer !== false) {
        this.fields = pick(this.$account.current.customer.informations, ['name', 'email', 'address'])
        if (this.fields.address.country) this.fields.address.country = this.fields.address.country.toLowerCase()
      } else {
        this.fields.name = this.$account.current.company ? this.$account.current.company : this.$account.current.first_name + ' ' + this.$account.current.last_name
        this.fields.email = this.$account.current.email
        this.fields.address.country = this.$account.current.country.toLowerCase()
      }

      // DEV
      if (process.env.VUE_APP_DEFAULT_CUSTOMER_NAME) this.fields.name = process.env.VUE_APP_DEFAULT_CUSTOMER_NAME
      if (process.env.VUE_APP_DEFAULT_CUSTOMER_ADDRESS_CITY) this.fields.address.city = process.env.VUE_APP_DEFAULT_CUSTOMER_ADDRESS_CITY
      if (process.env.VUE_APP_DEFAULT_CUSTOMER_ADDRESS_COUNTRY) this.fields.address.country = process.env.VUE_APP_DEFAULT_CUSTOMER_ADDRESS_COUNTRY
      if (process.env.VUE_APP_DEFAULT_CUSTOMER_ADDRESS_LINE1) this.fields.address.line1 = process.env.VUE_APP_DEFAULT_CUSTOMER_ADDRESS_LINE1
      if (process.env.VUE_APP_DEFAULT_CUSTOMER_ADDRESS_POSTAL_CODE) this.fields.address.postal_code = process.env.VUE_APP_DEFAULT_CUSTOMER_ADDRESS_POSTAL_CODE
      if (process.env.VUE_APP_DEFAULT_CUSTOMER_PHONE) this.fields.email = process.env.VUE_APP_DEFAULT_CUSTOMER_EMAIL
    }
  },
  mounted () {
    this.fill()
  }
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"hint-email": "The email that will be used to send you invoices related to your account.",
		"hint-name": "Your name or the name of your business which will be used on invoices.",
		"label-address": "Address*",
		"label-city": "City*",
		"label-country": "Country*",
		"label-cp": "Postal code*",
		"label-email": "Billing Email",
		"label-name": "Billing name*",
		"messages": {
			"fetching": "Updating contact details...",
			"success": "Billing details changed successfully",
			"updating": "Updating your contact details ..."
		},
		"required": {
			"address": "Address is required.",
			"city": "The city is required.",
			"country": "The country is required.",
			"cp": "The postal code is required.",
			"fields": "*required fields",
			"name": "Billing name is required."
		}
	},
	"es": {
		"hint-email": "El correo electrónico que se utilizará para enviarle las facturas relacionadas con su cuenta.",
		"hint-name": "Su nombre o el nombre de su empresa que se utilizará en las facturas.",
		"label-address": "Dirección*",
		"label-city": "Ciudad*",
		"label-country": "País*",
		"label-cp": "Código postal*",
		"label-email": "Correo Electrónico de Facturas",
		"label-name": "Nombre de facturación*",
		"messages": {
			"fetching": "Actualizando datos de contacto...",
			"success": "Los detalles de facturación se cambiaron correctamente",
			"updating": "Actualizando sus datos de contacto ..."
		},
		"required": {
			"address": "La dirección es necesaria.",
			"city": "La ciudad es necesaria.",
			"country": "El país es necesario.",
			"cp": "El código postal es necesaria.",
			"fields": "*campos requeridos",
			"name": "Se requiere el nombre de facturación."
		}
	},
	"fr": {
		"hint-email": "L'email qui sera utilisé pour vous envoyer les factures liées à votre compte.",
		"hint-name": "Votre nom ou le nom de votre entreprise qui sera utilisé sur les factures.",
		"label-address": "Adresse*",
		"label-city": "Ville*",
		"label-country": "Pays*",
		"label-cp": "Code postal*",
		"label-email": "Email de facturation",
		"label-name": "Nom de facturation*",
		"messages": {
			"fetching": "Actualisation des coordonnées ...",
			"success": "Coordonnées de facturation modifiées avec succès",
			"updating": "Mise à jour de vos coordonnées ..."
		},
		"required": {
			"address": "L'adresse est requise.",
			"city": "La ville est requise.",
			"country": "Le pays est requis.",
			"cp": "Le code postal est requis.",
			"fields": "*champs requis",
			"name": "Le nom de facturation est requis."
		}
	},
	"it": {
		"hint-email": "L'email che verrà usata per inviarti le fatture relative al tuo account.",
		"hint-name": "Il tuo nome o il nome della tua azienda che verrà usato sulle fatture.",
		"label-address": "Indirizzo*",
		"label-city": "Città*",
		"label-country": "Paese*",
		"label-cp": "Codice postale*",
		"label-email": "Email di fatturazione",
		"label-name": "Nome di fatturazione*",
		"messages": {
			"fetching": "Aggiornamento dei dati di contatto...",
			"success": "Dati di fatturazione modificati con successo",
			"updating": "Aggiornamento dei tuoi dati di contatto ..."
		},
		"required": {
			"address": "L'indirizzo è obbligatorio.",
			"city": "La città è obbligatoria.",
			"country": "Il paese è obbligatorio.",
			"cp": "Il codice postale è obbligatorio.",
			"fields": "*campi obbligatori",
			"name": "Il nome di fatturazione è obbligatorio."
		}
	},
	"pt": {
		"hint-email": "O email que será utilizado para lhe enviar as faturas relacionadas com a sua conta.",
		"hint-name": "O seu nome ou o nome da sua empresa que será utilizado nas faturas.",
		"label-address": "Morada*",
		"label-city": "Cidade*",
		"label-country": "País*",
		"label-cp": "Código postal*",
		"label-email": "Email de faturação",
		"label-name": "Nome de faturação*",
		"messages": {
			"fetching": "A atualizar os dados de contacto...",
			"success": "Dados de faturação alterados com sucesso",
			"updating": "A atualizar os seus dados de contacto ..."
		},
		"required": {
			"address": "A morada é obrigatória.",
			"city": "A cidade é obrigatória.",
			"country": "O país é obrigatório.",
			"cp": "O código postal é obrigatório.",
			"fields": "*campos obrigatórios",
			"name": "O nome de faturação é obrigatório."
		}
	},
	"pl": {
		"hint-email": "Email, który będzie używany do wysyłania Ci faktur związanych z Twoim kontem.",
		"hint-name": "Twoje imię lub nazwa firmy, która będzie używana na fakturach.",
		"label-address": "Adres*",
		"label-city": "Miasto*",
		"label-country": "Kraj*",
		"label-cp": "Kod pocztowy*",
		"label-email": "Email do faktur",
		"label-name": "Nazwa do faktur*",
		"messages": {
			"fetching": "Aktualizacja danych kontaktowych ...",
			"success": "Dane do faktur zostały pomyślnie zmienione",
			"updating": "Aktualizacja Twoich danych kontaktowych ..."
		},
		"required": {
			"address": "Adres jest wymagany.",
			"city": "Miasto jest wymagane.",
			"country": "Kraj jest wymagany.",
			"cp": "Kod pocztowy jest wymagany.",
			"fields": "*wymagane pola",
			"name": "Nazwa do faktur jest wymagana."
		}
	}
}
</i18n>
